<template>
  <div>
    <div class="select">
      <h4 class="title1">
        <span>&nbsp;&nbsp;筛选条件</span>
      </h4>
      <div class="selectColor">
        <div class="row">
          <el-row :gutter="20">
            <el-col :span="7">
              <el-row>
                <el-col :span="7">
                  机构
                </el-col>
                <el-col :span="17">
                  <el-cascader placeholder="请输入" :options="options" filterable change-on-select v-model="manageCom"></el-cascader>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="10">
              <el-row>
                <el-col :span="4">
                  时间区间
                </el-col>
                <el-col :span="20">
                  <el-date-picker
                    type="daterange"
                    align="right"
                    unlink-panels
                    :editable="false"
                    :clearable="false"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy-MM-dd"
                    @change="dateChange"
                    v-model="dateStart"
                    :default-value="dateStart"
                    class="maxWidth"
                    :picker-options="pickerOptions2"
                  >
                  </el-date-picker>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="7">
              <el-row>
                <el-col :span="7">考试类型</el-col>
                <el-col :span="17">
                  <el-select v-model="req.examType" placeholder="请选择">
                    <el-option label="全部" :value="null">全部</el-option>
                    <el-option label="新人" :value="0">新人</el-option>
                    <el-option label="地区" :value="1">地区</el-option>
                    <el-option label="互联网" :value="2">互联网</el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="row">
        <div>
          <el-row :gutter="20">
            <el-col :span="7">
              <el-row>
                <el-col :span="7">汇总类型</el-col>
                <el-col :span="17">
                  <el-select v-model="req.summaryType" placeholder="请选择" @change="summaryTypeChange">
                    <el-option label="全国" :value="0" v-if="show">全国</el-option>
                    <el-option label="分公司" :value="1">分公司</el-option>
                    <el-option label="机构" :value="2">机构</el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
            <div class="btnp">
              <el-button type="primary" @click="reset()">重置</el-button>
              <el-button type="primary" @click="search()">查询</el-button>
            </div>
            <!-- <el-col :span="2" :offset="14">
              <el-button type="primary" @click="reset()">重置</el-button>
            </el-col>
            <el-col :span="2" :offset="0">
              <el-button type="primary" @click="search()">查询</el-button>
            </el-col> -->
          </el-row>

        </div>
      </div>
    </div>
    <div class="main">
      <h4 class="title1"><span>&nbsp;&nbsp;查询结果</span> <el-button class="right" type="primary" @click="exportResult">导出</el-button></h4>
      <div>
        <el-table :data="result" style="width: 100%">
          <el-table-column type="index" label="序号" align="center"> </el-table-column>
          <el-table-column prop="t2Name" label="T2名称" width="100" align="center"> </el-table-column>
          <el-table-column prop="t2Code" label="T2代码" width="100" align="center"> </el-table-column>
          <el-table-column prop="t3Name" label="T3名称" width="100" align="center" v-if="T3"> </el-table-column>
          <el-table-column prop="t3Code" label="T3代码" width="100" align="center" v-if="T3"> </el-table-column>
          <el-table-column prop="t4Name" label="T4名称" width="100" align="center" v-if="T4"> </el-table-column>
          <el-table-column prop="t4Code" label="T4代码" width="100" align="center" v-if="T4"> </el-table-column>
          <el-table-column prop="examPeople" label="参考人数" width="100" align="center"> </el-table-column>
          <el-table-column prop="passPeople" label="通过人数" width="100" align="center"> </el-table-column>
          <el-table-column prop="examNum" label="参考人次" width="100" align="center"> </el-table-column>
          <el-table-column prop="passNum" label="通过人次" width="100" align="center"> </el-table-column>
          <el-table-column prop="phoneNum" label="参考手机终端数" width="150" align="center"> </el-table-column>
          <el-table-column prop="padNum" label="参考PAD终端数" width="150" align="center"> </el-table-column>
          <el-table-column prop="pcNum" label="参考PC终端数" width="150" align="center"> </el-table-column>
          <el-table-column prop="eX" label="e行考试人数" width="150" align="center"> </el-table-column>
          <el-table-column prop="qW" label="企微考试人数" width="150" align="center"> </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          class="my-pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="req.startIndex"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          prev-click
          next-click
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/modules/api.js';
import url from '@/modules/url.js';
export default {
  data() {
    return {
      dateStart: '',
      options: [{}],
      manageCom: [],
      manageCom1: [],
      req: {
        manageCom: 'HO',
        examType: null,
        startDate: '',
        endDate: '',
        startIndex: 1,
        pageSize: 10,
        summaryType: 0
      },
      T3: false,
      T4: false,
      total: 0,
      result: [],
      loadUrl: '',
      show:true,
      pickerOptions2: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      }
    };
  },
  methods: {
    reset() {
      // 重置
      this.manageCom = this.manageCom1;
      this.initDate();
      this.req.manageCom = this.manageCom;
      this.req.examType = null;
      this.req.startIndex = 1;
      this.req.pageSize = 10;
      this.req.summaryType = this.show?0:1;
      this.T3= this.show?false:true
      this.T4 =false
      this.initManageCom()
      // this.search();
    },
    summaryTypeChange(value) {
      if (value === 0) {
        this.T3 = false;
        this.T4 = false;
      }
      if (value === 1) {
        this.T3 = true;
        this.T4 = false;
      }
      if (value === 2) {
        this.T3 = true;
        this.T4 = true;
      }
    },
    initManageCom() {
      let that = this;
      api.post(url.initAllManageCom, {}, function(res) {
        console.log('机构', res);
        that.options = JSON.stringify(res.data)
          .trim()
          .replace(/"children":\[\],/g, '');
        console.log(that.options);
        that.options = JSON.parse(that.options);
        // console.log(123,that.options[0].vale)
        that.manageCom = that.options[0].value;
        that.manageCom1 = that.options[0].value;
        that.req.manageCom = that.options[0].value;
        if(!sessionStorage.getItem('show')){
          that.show=false
          that.req.summaryType=1
          that.T3 = true;
          that.T4 = false;
        }
        that.search();
        // that.options.push({label: '全国', value: 'HO'})
      });
    },
    search() {
      let that = this;
      api.post(url.getExamSummary, this.req, function(res) {
        that.total = res.data.total;
        that.result = res.data.data;
      });
    },
    // --------分页
    handleSizeChange(value) {
      this.req.pageSize = value;
      this.req.startIndex = 1;
      this.search();
    },
    handleCurrentChange(value) {
      this.req.startIndex = value;
      this.search();
    },
    dateChange(value) {
      let startDate = new Date(value[0]);
      let endDate = new Date(value[1]);

      this.req.startDate = startDate.getTime();
      this.req.endDate = endDate.getTime();
    },
    initDate() {
      let current = new Date();
      let startOfMonth = this.moment(current)
        .startOf('month')
        .format('YYYY/MM/DD');
      let endOfMonth = this.moment(current)
        .endOf('month')
        .format('YYYY/MM/DD');
      this.req.startDate = new Date(startOfMonth).getTime();
      this.req.endDate = new Date(endOfMonth).getTime();
      this.dateStart = [new Date(startOfMonth), new Date(endOfMonth)];
    },
    exportResult() {
      let that = this;
      api.post(url.exportExamSummary, this.req, function(res) {
        if (res.result.isSuccess) {
          that.loadUrl = res.data;
        } else {
          console.log('失败');
        }
      });
    }
  },
  watch: {
    manageCom(newValue, oldValue) {
      if (newValue.length === 1 && oldValue.length != 0) {
        this.req.manageCom = newValue[0];
      }
      if (newValue.length === 2 && oldValue.length != 0) {
        this.req.manageCom = newValue[1];
      }
      if (newValue.length === 3 && oldValue.length != 0) {
        this.req.manageCom = newValue[2];
      }
    },
    loadUrl(newValue, oldValue) {
      console.log(newValue);
      let a = document.createElement('a');
      a.style.display = 'none';
      a.href = newValue;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  },
  mounted() {
    this.initDate();
    this.initManageCom();
    // this.search()
  }
};
</script>

<style scoped>
.title1 {
  background: #e0e0e0;
  height: 50px;
  line-height: 50px;
  margin: 0px 0px 0px 0px;
}
.selectColor {
  padding-bottom: 1px;
}
.row {
  margin-top: 20px;
  padding-left: 20px;
  line-height: 50px;
}
.footer {
  padding: 10px 0 30px 0;
}
.right {
  margin: 5px 22px 0 0;
  float: right;
}
.my-pagination {
  float: right;
}
.maxWidth {
  width: 100%;
}
.select >>> .el-row{
  width:100%;
  padding-left:0;
  padding-right:0;
  margin-left: 0;
  margin-right: 0;
}
.btnp{
  margin-right: 12px;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/pages/exam/examManage/examTotal.vue